import { useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { IdCard, MessagesSquare } from 'lucide-react'
import { useT } from '@/i18n'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn, RowAction } from '@/components/DataTable/types'
import { fetchGroups, type AdminGroupRow } from '@/lib/adapters'
import { PERMISSIONS } from '@/lib/permissions'

/**
 * A4.01 — Guruhlar va kanallar ro'yxati (moderatsiya). GET /admin/groups
 * (backend `744a935`). dialogs WHERE type IN (group,channel).
 */
export function GroupsScreen() {
  const t = useT()
  const navigate = useNavigate()

  const rowActions = useMemo<RowAction<AdminGroupRow>[]>(
    () => [
      {
        id: 'card',
        label: t.users.viewCard,
        icon: <IdCard size={13} />,
        onSelect: (r) => navigate(`/groups/${r.id}`),
      },
    ],
    [t, navigate],
  )

  const columns = useMemo<AdminColumn<AdminGroupRow>[]>(
    () => [
      {
        key: 'type',
        header: t.col.type,
        type: 'enum',
        width: 110,
        options: [
          { value: 'group', label: t.groups.group, status: 'active' },
          { value: 'channel', label: t.groups.channel, status: 'review' },
        ],
      },
      { key: 'title', header: t.col.title, type: 'text', minWidth: 200 },
      { key: 'username', header: t.col.username, type: 'text', width: 160 },
      { key: 'member_count', header: t.groups.members, type: 'number', width: 110 },
      { key: 'is_forum', header: t.groups.forum, type: 'bool', width: 90 },
      { key: 'created_at', header: t.col.registered, type: 'date', width: 150 },
    ],
    [t],
  )

  const fetcher = useCallback(fetchGroups, [])

  return (
    <>
      <PageHeader title={t.nav.groups} screenId="A4.01" verified />
      <DataTable<AdminGroupRow>
        screenId="A4.01"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        rowActions={rowActions}
        exportable
        emptyState={{ icon: <MessagesSquare size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
